import React, { Fragment } from "react";

const BlockedUserItem = ({
  setUnblockUser,
  friend: {
    role,
    channelid,
    avatar,
    firstname,
    lastname,
    companyname,
    jobtitle,
    location,
  },
}) => {
  return (
    <Fragment>
      {role === "innovator" && (
        <div className="user-section-alt">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="friend-user-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font">
                      {firstname} {lastname}
                    </span>
                  </li>
                  <li className="user-online-item">{jobtitle}</li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                className="setting-friend-button background-green"
                onClick={() =>
                  setUnblockUser({
                    request: true,
                    confirm: false,
                    role,
                    channelid,
                    avatar,
                    firstname,
                    lastname,
                    companyname,
                    jobtitle,
                    location,
                  })
                }
              >
                <i className="fas fa-ban mx-5"></i>
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
      {role === "mentor" && (
        <div className="user-section-alt">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="friend-user-avi"
                  alt="friend-avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">
                      {firstname} {lastname}
                    </span>
                  </li>
                  <li className="user-online-item">{jobtitle}</li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                className="setting-friend-button background-red"
                onClick={() =>
                  setUnblockUser({
                    request: true,
                    confirm: false,
                    role,
                    channelid,
                    avatar,
                    firstname,
                    lastname,
                    companyname,
                    jobtitle,
                    location,
                  })
                }
              >
                <i className="fas fa-ban mx-5"></i>
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
      {role === "employer" && (
        <div className="user-section-alt">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="friend-user-avi"
                  alt="user-avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">{companyname}</span>
                  </li>
                  <li className="user-online-item">
                    {firstname} {lastname}
                  </li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                className="setting-friend-button background-blue"
                onClick={() =>
                  setUnblockUser({
                    request: true,
                    confirm: false,
                    role,
                    channelid,
                    avatar,
                    firstname,
                    lastname,
                    companyname,
                    jobtitle,
                    location,
                  })
                }
              >
                <i className="fas fa-ban mx-5"></i>
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
      {role === "company" && (
        <div className="user-section-alt">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="friend-user-avi"
                  alt="company-avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">{companyname}</span>
                  </li>
                  <li className="user-online-item">
                    {location.city}, {location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                className="setting-friend-button background-blue"
                onClick={() =>
                  setUnblockUser({
                    request: true,
                    confirm: false,
                    role,
                    channelid,
                    avatar,
                    firstname,
                    lastname,
                    companyname,
                    jobtitle,
                    location,
                  })
                }
              >
                <i className="fas fa-ban mx-5"></i>
                Unblock
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default BlockedUserItem;
